import styled from 'styled-components';

import ThemeHelper from '@themes/theme-helper';

export const Wrapper = styled.div(props => {
  const { colours } = ThemeHelper.getTheme(props);

  return `
    display: flex;
    flex-direction: column;
    min-height: calc(100% - 192px);
    border: 1px solid ${colours.grey[400]};;
    background-color: ${colours.grey[200]};
  `;
});

export const Header = styled.header(props => {
  const { colours } = ThemeHelper.getTheme(props);

  return `
      display: flex;
      position: sticky;
      top: 192px;
      z-index: 1;
      width: 54px;
      height: 47px;
      min-height: 47px;
      background-color: ${colours.grey[400]};
      border-right: 1px solid ${colours.grey[500]};
      box-sizing: border-box;
  `;
});

export const GridColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const Cell = styled.span(props => {
  const { colours } = ThemeHelper.getTheme(props);

  return `
    display: flex;
    align-items: center;
    justify-content: center;
    
    border: ${`1px solid ${colours.grey[400]}`};
    width: 54px;
    height: 33px;
    box-sizing: border-box;
    font-size: 14px;
    background-color: ${colours.grey[100]};
  `;
});



// WEBPACK FOOTER //
// ./components/grid/collapsed/styled.js